import moment from 'moment';
import { FC, useState } from 'react';
import { PAST_7_DAYS } from 'ui/datePicker/helpers';
import { guessCurrentTimeZone } from 'utils/timeZone';
import { DateParams, Preset } from '../types';
import { TimeFiltersContext } from './TimeFiltersContext';

export const TimeFiltersContextProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const [dateParams, setDateParams] = useState<DateParams>({
    startTime: moment().subtract(7, 'd'),
    endTime: moment(),
  });
  const [timezone, setTimezone] = useState(guessCurrentTimeZone());
  const [timePreset, setTimePreset] = useState(PAST_7_DAYS as Preset);

  return (
    <TimeFiltersContext.Provider
      value={{ dateParams, setDateParams, timezone, setTimezone, timePreset, setTimePreset }}
    >
      {children}
    </TimeFiltersContext.Provider>
  );
};
